import type { OrganizationWorkflowPayload } from '@Application/Organizations/Workflows/Actions/organizationWorkflowsFetched';

export type OrganizationWorkflowSavedAction = {
	type: 'ORGANIZATION_WORKFLOW_SAVED';
	payload: OrganizationWorkflowPayload;
	organizationId: number;
};

export default (
	payload: OrganizationWorkflowPayload,
	organizationId: number,
): OrganizationWorkflowSavedAction => ({
	type: 'ORGANIZATION_WORKFLOW_SAVED',
	payload,
	organizationId,
});
